/** P&L lines populated from Central Expense module (Expenses page). */
export const PNL_CENTRAL_EXPENSE_LINE_IDS = [
  'A34',
  'A41',
  'A42',
  'A42C',
  'A43',
  'A44',
  'A45',
  'A45C',
  'A49',
  'A49C',
  'A50',
  'A50C',
] as const;

export type PnlCentralExpenseLineId = (typeof PNL_CENTRAL_EXPENSE_LINE_IDS)[number];

export function isPnlCentralExpenseLineId(lineId: string): lineId is PnlCentralExpenseLineId {
  return (PNL_CENTRAL_EXPENSE_LINE_IDS as readonly string[]).includes(lineId);
}

const SALARY_CATS = ['SALARY', 'SALARY_ADVANCE', 'INCENTIVES_BONUS'];
const OFFICE_CATS = [
  'ELECTRICITY',
  'PANTRY_KITCHEN',
  'HOUSEKEEPING_MATERIAL',
  'DIESEL_GENERATOR',
  'LAUNDRY',
  'WATER',
  'INTERNET',
  'TEAM_ENGAGEMENT',
  'MAINTENANCE',
  'CLIENT_ENGAGEMENT',
];
const CAPEX_CATS = ['CAPEX_HOSPITAL', 'EQUIPMENT_PURCHASE'];

export function pnlExpenseCategoryHints(
  lineId: string,
  consolidated: boolean
): { categories: string[]; note?: string } | null {
  switch (lineId) {
    case 'A34':
      return {
        categories: ['ONLINE_MARKETING'],
        note: 'P&L may show unit share allocated by aesthetic IPD count.',
      };
    case 'A41':
      return { categories: ['HOSPITAL_RENT', 'PROFESSIONAL_FEES'] };
    case 'A42':
      return {
        categories: SALARY_CATS,
        note: consolidated ? 'Hospital units only (excludes Central tag).' : undefined,
      };
    case 'A42C':
      return consolidated
        ? { categories: SALARY_CATS, note: 'Hospital – Central tag only.' }
        : null;
    case 'A43':
      return { categories: OFFICE_CATS };
    case 'A44':
      return { categories: ['OXYGEN_CYLINDER', 'LOCUM', 'BIOMEDICAL_WASTE'] };
    case 'A45':
      return {
        categories: [],
        note: 'Other unmapped central expense categories under ₹50,000 (hospital units).',
      };
    case 'A45C':
      return consolidated
        ? {
            categories: [],
            note: 'Other unmapped central-level expenses under ₹50,000.',
          }
        : null;
    case 'A49':
      return { categories: CAPEX_CATS, note: consolidated ? 'Hospital units only.' : undefined };
    case 'A49C':
      return consolidated ? { categories: CAPEX_CATS, note: 'Central tag only.' } : null;
    case 'A50':
      return {
        categories: [],
        note: 'Unmapped hospital-unit expenses at/above ₹50,000.',
      };
    case 'A50C':
      return consolidated
        ? {
            categories: ['FUNDING_EXPENSES'],
            note: 'Funding expenses plus other central unmapped expenses ≥ ₹50,000.',
          }
        : null;
    default:
      return null;
  }
}

export function formatExpenseCategoryLabel(category: string): string {
  return category
    .split('_')
    .map((w) => w.charAt(0) + w.slice(1).toLowerCase())
    .join(' ');
}
